// Master-detail split layout for Organize — desktop side-by-side, mobile drawer
import { Box, Paper, Typography, IconButton, Drawer, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useBreakpoint } from '@/hooks/ui/useBreakpoint';
import { useT } from '@/i18n/useT';

export default function OrganizeSplitPane({
  master,
  detail,
  detailVisible,
  onCloseDetail,
}) {
  const t = useT();
  const currentBreakpoint = useBreakpoint();
  const isSmallScreen = currentBreakpoint === 'xs' || currentBreakpoint === 's';

  if (isSmallScreen) {
    return (
      <Box
        sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}
      >
        <Paper
          variant="outlined"
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              overflowY: 'auto',
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {master}
          </Box>
        </Paper>
        <Drawer
          anchor="bottom"
          open={detailVisible}
          onClose={onCloseDetail}
          PaperProps={{
            sx: {
              maxHeight: '85vh',
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            },
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
            <IconButton
              size="small"
              onClick={onCloseDetail}
              aria-label={t('modal.close', 'Close')}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          {detail}
        </Drawer>
      </Box>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{ display: 'flex', flex: 1, minHeight: 0, overflow: 'hidden' }}
    >
      <Box
        sx={{
          flex: '0 0 35%',
          borderRight: 1,
          borderColor: 'divider',
          overflowY: 'auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {master}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, overflowY: 'auto', minHeight: 0 }}>
        <Fade key={detailVisible ? 'detail' : 'empty'} in timeout={150}>
          <Box sx={{ height: '100%' }}>
            {detailVisible ? (
              detail
            ) : (
              <Box sx={{ p: 3, color: 'text.subtle' }}>
                <Typography variant="body2">
                  {t(
                    'organize.selectTask',
                    'Selecteer een taak om details te zien',
                  )}
                </Typography>
              </Box>
            )}
          </Box>
        </Fade>
      </Box>
    </Paper>
  );
}
